import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

function DetailsItems(props) {
    const items = props.items || [];

    return(
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Internal SKU</TableCell>
                    <TableCell>External SKU</TableCell>
                    <TableCell>Quantity</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {items.map((item, index) => {
                    return(
                        <TableRow key={index}>
                            <TableCell>{item.internal_sku}</TableCell>
                            <TableCell>{item.external_sku || "N/A"}</TableCell>
                            <TableCell>{item.quantity}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}

export default DetailsItems;